// src/services/AuthConfig.js
import { PublicClientApplication } from '@azure/msal-browser';

export const msalConfig = {
    auth: {
        clientId: '4fb3184d-85af-4a84-aeec-432a7c759942', 
        authority: 'https://login.microsoftonline.com/fcb2b37b-5da0-466b-9b83-0014b67a7c78',
        redirectUri: window.location.origin + '/',
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
    }
};

export const tokenRequest = {
    scopes: ["https://bayer.com/prod-baychatgpt-api/.default"]
}

export const loginRequest = {
    scopes: ['User.Read']
};

export const msalInstance = new PublicClientApplication(msalConfig);